export const jsonToCsv = (jsonData) => {
  if (!Array.isArray(jsonData) || !jsonData.length) {
    return "";
  }

  // Get all fields
  const fields = Object.keys(jsonData[0]);

  // Create header row
  const csvRows = [fields.join(",")];

  // Create data rows
  jsonData.forEach((item) => {
    const row = fields.map((field) => {
      const value = item[field];
      // Handle values that might contain commas or quotes
      if (
        typeof value === "string" &&
        (value.includes(",") || value.includes('"'))
      ) {
        return `"${value.replace(/"/g, '""')}"`;
      }
      return value;
    });
    csvRows.push(row.join(","));
  });

  return csvRows.join("\n");
};

export const downloadCsv = (csv, filename) => {
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  let element = document.createElement("a");
  element.href = URL.createObjectURL(blob);
  element.download = filename;
  element.click();
};
